exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".notification-details .checkbox {\n  width: 100%;\n}\n.notification-details .checklist {\n  -webkit-padding-start: 0px;\n     -moz-padding-start: 0px;\n          padding-inline-start: 0px;\n}\n", ""]);

